import {
  CONTACT_POINT_SYSTEM,
  PROPERTY_OWNERSHIP,
  REGEX_EXPS,
} from "utils/constants";
import { normalizeTextField, stripAllSpaces } from "utils/helpers/validations";
import * as yup from "yup";

const validation = (messages) => {
  const requiredName = yup
    .string()
    .transform(normalizeTextField)
    .typeError(messages.REQUIRED)
    .matches(REGEX_EXPS.name, messages.INVALID_NAME)
    .required(messages.REQUIRED);
  return yup.object().shape({
    contact: yup.object().shape({
      familySituation: yup.string().nullable().required(messages.REQUIRED),
      fields: yup.object().shape({
        propertyOwnership: yup.string().nullable().required(messages.REQUIRED),
        profile: yup.string().nullable().required(messages.REQUIRED),
        mobileMeans: yup
          .array()
          .of(yup.string())
          .nullable()
          .required(messages.REQUIRED),
        remainingLoanYears: yup
          .number()
          .nullable()
          .when("propertyOwnership", {
            is: PROPERTY_OWNERSHIP.OWNED,
            then: (schema) => schema.required(messages.REQUIRED),
            otherwise: (schema) => schema.notRequired(),
          }),
      }),
      socioProfessionalCategory: yup
        .string()
        .nullable()
        .required(messages.REQUIRED),
      user: yup.object().shape({
        firstname: requiredName,
        lastname: requiredName,
        birthDate: yup.date().nullable().required(messages.REQUIRED),
      }),
      telecoms: yup.object().shape({
        [CONTACT_POINT_SYSTEM.ZIP_CODE]: yup.object().shape({
          value: yup
            .string()
            .nullable()
            .matches(REGEX_EXPS.zipCode, messages.INVALID_ZIP_CODE)
            .required(messages.REQUIRED),
        }),
        [CONTACT_POINT_SYSTEM.EMAIL]: yup.object().shape({
          value: yup
            .string()
            .nullable()
            .email(messages.EMAIL)
            .required(messages.REQUIRED),
        }),
        [CONTACT_POINT_SYSTEM.PHONE]: yup.object().shape({
          value: yup
            .string()
            .transform(stripAllSpaces)
            .typeError(messages.REQUIRED)
            .required(messages.REQUIRED)
            .test("isValid", messages.INVALID_VALUE, async function (value) {
              return new RegExp(REGEX_EXPS.phone).test(value);
            }),
        }),
      }),
    }),
    members: yup.array().of(
      yup.object().shape({
        firstName: requiredName,
        lastName: requiredName,
        birthDate: yup.date().nullable().required(messages.REQUIRED),
        relationship: yup.string().nullable().required(messages.REQUIRED),
      }),
    ),
  });
};

export default validation;
